import { PureComponent } from 'react';

class Tooltip extends PureComponent {
    render() {
        return (
            <div className={`ave-tooltip-wrapper ${this.props.className || ""}`}>
                <span className={`ave-tooltip ${this.props.borderClassName || ""}`}>
                    <span className={`${this.props.layoutClassName || ""}` }>
                        {
                            this.props.title && <span className="ave-tooltip-title">{this.props.title}</span>
                        }
                        <span>{this.props.text}</span>
                        <span className={`ave-tooltip-triangle ${this.props.borderClassName || ""}`}></span>
                    </span>
                </span>
            </div>
        );
    }
}

export default Tooltip;